import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IFrame } from 'src/components/ui/GlobalComponents/IFrame/IFrame';
import { PageHeader } from 'src/components/ui/GlobalComponents/PageHeader/PageHeader';
import { useAds } from 'src/hook/data/useAds';
import { useHearts } from 'src/hook/data/useHearts';
import useUser from 'src/hook/data/useUser';
import { useToast } from 'src/hook/global/useToasts';
import { PageSource } from 'src/model/enum/enums';
import { GetRazorSiteUrl } from 'src/utils/URLUtils';
import styles from './EarnHeart.module.scss';

export const EarnHeart = () => {
    const { t } = useTranslation();
    const { userInfo, isProUser } = useUser();
    const navigate = useNavigate();
    const toast = useToast();
    const { checkAdHearts } = useHearts();
    const { setPageSource } = useAds();


    useEffect(() => {
        if (isProUser()) return;
        const handleMessage = (event: MessageEvent) => {
            if (event.data.type === 'NAVIGATION_TO_DOMAIN') {
                const url = event.data.url;
                if (url === 'show-ads') {
                    if (userInfo?.Hearts && userInfo.Hearts > 0) {
                        toast.showInfo(t('You can see Ads when you run out of hearts'));
                        return;
                    }
                    else if (!checkAdHearts()) {
                        toast.showInfo(t('You have already watched ads two times today.'));
                        return;
                    }
                    else {
                        setPageSource(PageSource.EranHeart);
                    }
                }

                navigate(`/${url}`);
            }
        };

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, [navigate, isProUser, userInfo?.Hearts, toast, checkAdHearts, setPageSource]);


    return (
        <div className={styles.earnHeart}>
            <PageHeader handleBackClick={() => navigate('/challenges')} />
            <IFrame
                src={GetRazorSiteUrl('pro/earn-heart', userInfo?.Token, `total=${userInfo?.Hearts}`)}
            />
        </div>
    );
}; 